export default __webpack_public_path__ + "resources/icons/d320-0f93.png";